import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const calendarsSelector = (state: IAppState) => state.workingTimeSchema.calendarState;

export const getBaseCalendarList = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.calendarList
);

export const getNonWorkingDays = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.customUserCalendar.filter((workingTimeS: IWorkingTimeSchema) => {
        return workingTimeS.isWorking === false
      }),
);
export const getBaseCalendarByUser = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.baseCalendar
);

export const getCalendarDic = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.calendarsDict
);

export const getCustomHours = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.customUserCalendar.filter((workingTimeS: IWorkingTimeSchema) => {
        return workingTimeS.isWorking === true
      }),
);

export const getAllUserCalendars = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.customUserCalendar
);

export const getSelectedUser = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.selectedUser
);

export const getIsLoadingBase = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.isLoadingBase
);

export const getIsLoadingUserCalendars = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.isLoadingUserCalendars
);

export const getCustomToDelete = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.toDelete
);

export const getInitialBaseCalendarByUser = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.initialBaseCalendar
);

export const getInitialCustomCalendarByUser = createSelector(
    calendarsSelector,
    (state: ICalendarsState) => state.initialCustomUserCalendar
);
